// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-preview-section {
  margin-bottom: 24px;
}
.billing-preview-section .billing-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
.billing-preview-section .billing-preview-stats {
  margin-bottom: 16px;
}
.billing-preview-section .billing-preview-detail {
  margin-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/billing/internal-invoices/billing-preview-cards.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAFA;EAII,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AACJ;AAVA;EAaI,mBAAA;AAAJ;AAbA;EAiBI,mBAAA;AADJ","sourcesContent":[".billing-preview-section {\n  margin-bottom: 24px;\n\n  .billing-preview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .billing-preview-stats {\n    margin-bottom: 16px;\n  }\n\n  .billing-preview-detail {\n    margin-bottom: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
